import { render, staticRenderFns } from "./LoopMain.vue?vue&type=template&id=0ae9cc98"
import script from "./LoopMain.vue?vue&type=script&lang=js"
export * from "./LoopMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae9cc98')) {
      api.createRecord('0ae9cc98', component.options)
    } else {
      api.reload('0ae9cc98', component.options)
    }
    module.hot.accept("./LoopMain.vue?vue&type=template&id=0ae9cc98", function () {
      api.rerender('0ae9cc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/components/LoopMain.vue"
export default component.exports